import _ from 'lodash';
import {AppName, getAppName} from "util/AppName"

export interface AppScope {
	persNr?: number
	date?: number
	dateEnd?: number
	costId?: string
}

/*************************************************************************************************
 * private
 *************************************************************************************************/

const lsPrefix = "SisAppScope_";

function getLocalStorageNameFor(app: AppName) {
	return lsPrefix + app;
}

function getStore(lsName: string) {
	let ret;
	const item = localStorage.getItem(lsName);
	try {
		if (item) ret = JSON.parse(item);
	} catch (e) {
		//ignore
	}
	if (!_.isPlainObject(ret)) ret = {};
	return ret;
}

function saveStore(lsName: string, store: AppScope) {
	if (_.isEmpty(store)) {
		localStorage.removeItem(lsName);
	} else {
		localStorage.setItem(lsName, JSON.stringify(store));
	}
}

/*************************************************************************************************
 * public
 *************************************************************************************************/

/**
 * @param name {String} property name
 * @param [remove] {boolean} default=true, should get removed after first usage to
 *  prevent app from staying in that scope
 */
function getScope(name: keyof AppScope, remove: boolean = true) {
	if (!localStorage || !name) return;
	if (remove !== false) remove = true;
	const lsName = getLocalStorageNameFor(getAppName());
	let store = getStore(lsName);
	const ret = store[name];
	if (remove) store = _.omit(store, name);
	saveStore(lsName, store);
	return ret;
}

/**
 * @param app {String} app name
 * @param scope {{}} with parameters that are supported by the app
 */
function openScoped(app?: AppName, scope?: AppScope) {
	if (!localStorage || !app || !scope) return;
	const lsName = getLocalStorageNameFor(app);
	saveStore(lsName, scope);

	window.open('./' + app + '.jsp', '_self');
}


export default {
	getScope: getScope,
	openScoped: openScoped,
};